/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CompromisedDevice } from './CompromisedDevice';
import {
    CompromisedDeviceFromJSON,
    CompromisedDeviceFromJSONTyped,
    CompromisedDeviceToJSON,
    CompromisedDeviceToJSONTyped,
} from './CompromisedDevice';

/**
 * 
 * @export
 * @interface PaginatedCompromisedDeviceList
 */
export interface PaginatedCompromisedDeviceList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedCompromisedDeviceList
     */
    count: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompromisedDeviceList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedCompromisedDeviceList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<CompromisedDevice>}
     * @memberof PaginatedCompromisedDeviceList
     */
    results: Array<CompromisedDevice>;
}

/**
 * Check if a given object implements the PaginatedCompromisedDeviceList interface.
 */
export function instanceOfPaginatedCompromisedDeviceList(value: object): value is PaginatedCompromisedDeviceList {
    if (!('count' in value) || value['count'] === undefined) return false;
    if (!('results' in value) || value['results'] === undefined) return false;
    return true;
}

export function PaginatedCompromisedDeviceListFromJSON(json: any): PaginatedCompromisedDeviceList {
    return PaginatedCompromisedDeviceListFromJSONTyped(json, false);
}

export function PaginatedCompromisedDeviceListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedCompromisedDeviceList {
    if (json == null) {
        return json;
    }
    return {
        
        'count': json['count'],
        'next': json['next'] == null ? undefined : json['next'],
        'previous': json['previous'] == null ? undefined : json['previous'],
        'results': ((json['results'] as Array<any>).map(CompromisedDeviceFromJSON)),
    };
}

  export function PaginatedCompromisedDeviceListToJSON(json: any): PaginatedCompromisedDeviceList {
      return PaginatedCompromisedDeviceListToJSONTyped(json, false);
  }

  export function PaginatedCompromisedDeviceListToJSONTyped(value?: PaginatedCompromisedDeviceList | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'count': value['count'],
        'next': value['next'],
        'previous': value['previous'],
        'results': ((value['results'] as Array<any>).map(CompromisedDeviceToJSON)),
    };
}

